import React from "react";
import Classes from "./styles/style.module.css";
import { useNavigate } from "react-router";
import Hint from "./../../assets/components/Hint";

const MatchMenu = (props) => {
  const navigate = useNavigate();
  return (
    <div className="row justify-content-between mt-5">
      <Hint hintText={"پایان فصل اول"} />
      <div
        className={`${Classes.startGameButton} ${Classes.disabledButton} mt-2`}
        // onClick={props.takeQuiz}
      >
        شروع چالش
      </div>
      {props.isMini ? null : (
        <>
          <div className="w-100 d-flex justify-content-between">
            <div
              className={`${Classes.socreButton}`}
              onClick={() => navigate("/leaderboard")}
            >
              جدول پیشتازان
            </div>
            <div className={`${Classes.rulesButton}`} onClick={props.showRules}>
              راهنمای چالش
            </div>
          </div>
          <div
            className={`${Classes.reviewButton} ${Classes.disabledButton} py-2`}
            // onClick={() => navigate("/quests")}
          >
            ماموریت ها
            <p className="mb-0">پله بیشتر</p>
          </div>
          <div className="w-100 d-flex justify-content-between">
            <div className={Classes.helperButton} onClick={props.showAwards}>
              جوایز
            </div>
            <div className={Classes.helperButton} onClick={props.showHint}>
              قوانین
            </div>
          </div>
          {/* <div
            className={`${Classes.reviewButton}`}
            onClick={() => navigate(`/khazane/${props.quizId}`)}
          >
            خزانه سوال
          </div> */}
          <div
            className={Classes.startGameButton}
            onClick={() => navigate("/profile")}
          >
            پروفایل
          </div>
        </>
      )}
    </div>
  );
};

export default MatchMenu;
